import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../App";
import { api, errMsg } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      signIn(data);
      const r = data.user.role;
      nav(r === "admin" ? "/admin" : r === "judge" ? "/judge" : "/dashboard");
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16 fade-up">
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#c8102e] mb-2">Welcome back</p>
      <h1 className="font-display text-3xl font-bold text-[#1a1f36] mb-6">Sign in</h1>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="email">Email or username</Label>
          <Input id="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@redstoneresidential.com or first.last" data-testid="login-email" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
        </div>
        <Button type="submit" disabled={busy} className="w-full sw-red hover:bg-red-700 text-white font-semibold" data-testid="login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </Button>
      </form>
      <div className="mt-4 flex justify-between text-sm">
        <Link to="/reset-password" className="text-[#c8102e] hover:underline" data-testid="forgot-password-link">Forgot password?</Link>
        <Link to="/register" className="text-slate-600 hover:underline" data-testid="go-register-link">Register your property</Link>
      </div>
    </div>
  );
}
